/** Date fields present on Primavera P6 TASK rows in .xer exports. */
export const XER_TASK_DATE_FIELDS = [
  'cstr_date',
  'act_start_date',
  'act_end_date',
  'late_start_date',
  'late_end_date',
  'expect_end_date',
  'early_start_date',
  'early_end_date',
  'restart_date',
  'reend_date',
  'target_start_date',
  'target_end_date',
  'review_end_date',
  'rem_late_start_date',
  'rem_late_end_date',
  'suspend_date',
  'resume_date',
  'cstr_date2',
  'external_early_start_date',
  'external_late_end_date',
  'create_date',
  'update_date',
] as const

export type XerTaskDateField = typeof XER_TASK_DATE_FIELDS[number]

export type XerTaskDates = {
  [K in XerTaskDateField]: string | null
}

export type XerTable = {
  fields: string[]
  rows: string[][]
}

export type XerTables = Record<string, XerTable>

export type XerWbsNode = {
  wbsId: string
  parentWbsId: string | null
  wbsName: string
  wbsShortName: string
}

export type XerTask = {
  taskId: string
  projId: string
  wbsId: string
  taskCode: string
  taskName: string
  taskType: string
  statusCode: string
  guid: string
  wbsPath: string
  dates: XerTaskDates
}

export type XerProjectMeta = {
  projId: string
  projShortName: string
  planStartDate: string | null
  scdEndDate: string | null
}

export type ParsedXerSchedule = {
  project: XerProjectMeta | null
  wbs: XerWbsNode[]
  tasks: XerTask[]
}

export type ScheduleTaskMapping = {
  taskId: string
  taskCode: string
  floorCode: string
  floorName: string
  trackerId: number
  trackerName: string
  /** ProjectJobType.id — required for new mappings */
  jobTypeId: number
  jobTypeName: string
}

export type ScheduleImportSession = {
  fileName: string
  projectPublicId: string | null
  schedule: ParsedXerSchedule
  mappings: ScheduleTaskMapping[]
}
